<template>
    <div>
        <Header/>
        <div class="zwB "></div>
        <div class="">
            <div class="rjxzBa bgimg1" style="background:#eee url(https://cdn.gda.top/image_after_2019_06/4974/android_down.png) no-repeat center top;width:100%;">
              <div class="content">
                <div class="text">
                  <div class="div1"><span class="span1">{{currentHomeText}}{{$t('exchange')}} —— {{currentVersion}}{{$t('release')}}</span></div>
                  <div class="div2"><span class="span2">{{$t('financial_core')}}&nbsp;{{$t('smart_core')}}&nbsp;{{$t('service_core')}}</span></div>
                </div>
                <div style="margin-left: 5%;margin-right: 0px; margin-top: 6%; text-align: center;">
                  <div>
                    <img style="width: 45%" src="https://cdn.gda.top/image_after_2019_06/4397/download.png" class="imgani14"/>
                  </div>
                  <div style="padding-top: 5%; display: flex; align-items: center; justify-content: center;">
                    <img style="width: 15%" src="https://cdn.gda.top/image_after_2019_06/3234/android_icon.png">
                    <span style="font-size: 18px"><strong>Android</strong></span>
                  </div>
                </div>
                <div style="margin-right: 0px; margin-top: 6%; text-align: center;">
                  <div>
                    <img style="width: 52%" src="https://cdn.gda.top/image_after_2019_06/4397/download.png" class="imgani14"/>
                  </div>
                  <div style="padding-top: 5%; display: flex; align-items: center; justify-content: center;">
                    <img style="width: 15%" src="https://cdn.gda.top/image_after_2019_06/2535/ios_icon.png">
                    <span style="font-size: 18px"><strong>Ios</strong></span>
                  </div>
                </div>
              </div>
            </div>
            <div class="clear"></div>
            <div class="ind_img gray bgimg2">
                <div class="content">
                  <div class="text">
                    <div class="div1"><span class="span1">{{$t('one_click_login_registration')}}</span></div>
                    <div class="div2"><span class="span2">{{$t('no_need_for_tedious_steps')}}</span></div>
                  </div>
                  <div class="mid mid4" style="padding-top: 59px;width: auto;margin-right: 0px;margin-left: 104px;">
                      <img :src="download_banner2_1_url" class="leftimg imgani7"/>
                      <img :src="download_banner2_2_url" class="bottomimg imgani8" style="margin-left: 20px;" />
                  </div>
                </div>
            </div>
            <div class="ind_img bgimg3">
                <div class="content">
                  <div class="mid mid5" style="padding-top: 59px;width: auto;margin-right: 104px;margin-left: 0px;">
                      <img :src="download_banner3_1_url" class="leftimg imgani11"/>
                      <img :src="download_banner3_2_url" class="leftimg imgani12" style="margin-left: 20px;" />
                  </div>
                  <div class="text">
                    <div class="div1"><span class="span1">{{$t('new_legal_currency_trading_interface')}}</span></div>
                    <div class="div2"><span class="span2">{{$t('financial_core')}}&nbsp;{{$t('smart_core')}}&nbsp;{{$t('service_core')}}</span></div>
                  </div>
                </div>
            </div>
            <div class="ind_img bgimg4">
              <div class="content">
                <div class="text">
                  <div class="div1"><span class="span1">{{$t('optimize_stock_trading_system')}}</span></div>
                  <div class="div2"><span class="span2">{{$t('no_need_for_tedious_steps')}}</span></div>
                </div>
                <div class="mid mid6" style="padding-top: 38px;width: auto;margin-left: 104px;margin-right: 0px;">
                    <img :src="download_banner4_url" class="rightimg imgani13"/>
                </div>
              </div>
            </div>
        </div>
        <Footer/>
    </div>
</template>
<script>
    import Footer from "../components/Footer";
    import Header from "../components/Header";
    import {zh_download_banner1,zh_download_banner2_1,zh_download_banner2_2,zh_download_banner3_1,zh_download_banner3_2,zh_download_banner4, en_download_banner1,en_download_banner2_1,en_download_banner2_2,en_download_banner3_1,en_download_banner3_2,en_download_banner4,jp_download_banner1,jp_download_banner2_1,jp_download_banner2_2,jp_download_banner3_1,jp_download_banner3_2,jp_download_banner4,kr_download_banner1,kr_download_banner2_1,kr_download_banner2_2,kr_download_banner3_1,kr_download_banner3_2,kr_download_banner4,ru_download_banner1,ru_download_banner2_1,ru_download_banner2_2,ru_download_banner3_1,ru_download_banner3_2,ru_download_banner4} from '../application'
    export default {
        components: {Header,Footer},
        computed:{
          download_banner1_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner1
            }else if(lang ==='en'){
              return en_download_banner1
            }else if(lang ==='jp'){
              return jp_download_banner1
            }else if(lang ==='kr'){
              return kr_download_banner1
            }else if(lang ==='ru'){
              return ru_download_banner1
            }
          },
          download_banner2_1_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner2_1
            }else if(lang ==='en'){
              return en_download_banner2_1
            }else if(lang ==='jp'){
              return jp_download_banner2_1
            }else if(lang ==='kr'){
              return kr_download_banner2_1
            }else if(lang ==='ru'){
              return ru_download_banner2_1
            }
          },
          download_banner2_2_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner2_2
            }else if(lang ==='en'){
              return en_download_banner2_2
            }else if(lang ==='jp'){
              return jp_download_banner2_2
            }else if(lang ==='kr'){
              return kr_download_banner2_2
            }else if(lang ==='ru'){
              return ru_download_banner2_2
            }
          },
          download_banner3_1_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner3_1
            }else if(lang ==='en'){
              return en_download_banner3_1
            }else if(lang ==='jp'){
              return jp_download_banner3_1
            }else if(lang ==='kr'){
              return kr_download_banner3_1
            }else if(lang ==='ru'){
              return ru_download_banner3_1
            }
          },
          download_banner3_2_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner3_2
            }else if(lang ==='en'){
              return en_download_banner3_2
            }else if(lang ==='jp'){
              return jp_download_banner3_2
            }else if(lang ==='kr'){
              return kr_download_banner3_2
            }else if(lang ==='ru'){
              return ru_download_banner3_2
            }
          },
          download_banner4_url:function () {
            let lang = this.currentLang || 'zh'
            if(lang ==='zh'){
              return zh_download_banner4
            }else if(lang ==='en'){
              return en_download_banner4
            }else if(lang ==='jp'){
              return jp_download_banner4
            }else if(lang ==='kr'){
              return kr_download_banner4
            }else if(lang ==='ru'){
              return ru_download_banner4
            }
          }
        },
        mounted() {
            // 定位动画
            var offsetTop1 ,offsetTop2 ,offsetTop3 ,offsetTop4 ,offsetTop5 ,offsetTop6 ;
            var scrollTop = 0;
            var windowHeight = 0;
            $(".mid1").find("img").animate({
                'top':0,
                'bottom':0,
                'left':0,
                'right':0,
                'opacity':1
            },1000);
            $(window).scroll(function(){
                scrollTop = $(window).scrollTop();
                windowHeight = $(window).height()-200;
                offsetTop4 = $(".mid4").offset().top;
                if(scrollTop>offsetTop4-windowHeight){
                    $(".mid4").find("img").animate({
                        'top':0,
                        'bottom':0,
                        'left':0,
                        'right':0,
                        'opacity':1
                    },1000);
                }
                offsetTop5 = $(".mid5").offset().top;
                if(scrollTop>offsetTop5-windowHeight){
                    $(".mid5").find("img").animate({
                        'top':0,
                        'bottom':0,
                        'left':0,
                        'right':0,
                        'opacity':1
                    },1000);
                }
                offsetTop6 = $(".mid6").offset().top;
                if(scrollTop>offsetTop6-windowHeight){
                    $(".mid6").find("img").animate({
                        'top':0,
                        'bottom':0,
                        'left':0,
                        'right':0,
                        'opacity':1
                    },1000);
                }
            })
        }
    }
</script>
<style lang="scss" scoped>
@import url('../css/2020_swiper.min.css');
@import url('../css/public_20200313v4.css');
@import url('../css/index.css');
@import url('../css/public_footer.css');
@import url('../css/zxStyle.css');
@import url('../css/zxPubliceStyle.css');
@import url('../css/shzr_zr2020.css');
.bgimg1{
  background: url(https://cdn.gda.top/image_after_2019_06/2695/down_bgimg2.png) no-repeat;
  background-size: 100% 100%;
}
.bgimg1 .content{
  display: flex;
  justify-content: center;
}
.bgimg1 .text{
  display: flex;
  flex-direction: column;
  padding-top: 160px;
}
.bgimg1 .text .span1{
  background-image: linear-gradient(135deg,#56d8ff,#1575ff);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 35px;
}
.bgimg1 .text .span2{
  color: #77a5ea;
  font-size: 26px;
}
.bgimg1 .text .div2{
  margin-top: 20px;
}


.bgimg2{
  background: url(https://cdn.gda.top/image_after_2019_06/2695/down_bgimg2.png) no-repeat;
  background-size: 100% 100%;
}
.bgimg2 .content{
  display: flex;
  justify-content: center;
}
.bgimg2 .text{
  display: flex;
  flex-direction: column;
  padding-top: 160px;
}
.bgimg2 .text .span1{
  background-image: linear-gradient(135deg,#56d8ff,#1575ff);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 35px;
}
.bgimg2 .text .span2{
  color: #77a5ea;
  font-size: 26px;
}
.bgimg2 .text .div2{
  margin-top: 20px;
}


.bgimg3{
  background: url(https://cdn.gda.top/image_after_2019_06/2692/down_bgimg3.png) no-repeat;
  background-size: 100% 100%;
}
.bgimg3 .content{
  display: flex;
  justify-content: center;
}
.bgimg3 .text{
  display: flex;
  flex-direction: column;
  padding-top: 160px;
}
.bgimg3 .text .span1{
  background-image: linear-gradient(135deg,#56d8ff,#1575ff);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 35px;
}
.bgimg3 .text .span2{
  color: #77a5ea;
  font-size: 26px;
}
.bgimg3 .text .div2{
  margin-top: 20px;
}

.bgimg4{
  background: url(https://cdn.gda.top/image_after_2019_06/2690/down_bgimg4.png) no-repeat;
  background-size: 100% 100%;
}
.bgimg4 .content{
  display: flex;
  justify-content: center;
}
.bgimg4 .text{
  display: flex;
  flex-direction: column;
  padding-top: 160px;
}
.bgimg4 .text .span1{
  background-image: linear-gradient(135deg,#56d8ff,#1575ff);
  -webkit-background-clip: text;
  color: transparent;
  font-size: 35px;
}
.bgimg4 .text .span2{
  color: #77a5ea;
  font-size: 26px;
}
.bgimg4 .text .div2{
  margin-top: 20px;
}
</style>
<!--<style src="../../public/css/zxPubliceStyle.css" scoped></style>-->
<!--<style src="../../public/css/zxStyle.css" scoped></style>-->
